import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Registration4.css";
import country from "../../country.json";
import { faHandFist } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Select from "react-select";
import { State } from "country-state-city";
import ReactSlider from "react-slider";
import Slider from '@mui/material/Slider';
import { BASE_URL } from "../../BASE_URL";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../Components/Loader/Loader";
import countries from "../../CountryStateCity.json"

function InsertPartenerPreference() {
  const [preferences, setPreferences] = useState(null);
  const token = localStorage.getItem("saptvidhiUserToken");
  // const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [authToken, setAuthToken] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const userDetails = async () => {
    const res = await fetch(
      `${BASE_URL}/api/profile/userdetails`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    const data = await res.json();

    setPreferences(data?.data?.UserDetails?.preference);

    if (data?.data?.UserDetails?.preference) {
      
      const selectedState = data?.data?.UserDetails?.preference?.[0]?.country;
      const selectedCity = data?.data?.UserDetails?.preference?.[0]?.state;
      const stateObject = countries.find((e) => e.name === selectedState)
      const cityObject = stateObject?.states?.find((e) => e.name === selectedCity)
      setStates(stateObject?.states)
      setCities(cityObject?.cities)

      setJobTitileInput(data?.data?.UserDetails?.preference?.[0]?.job_title);
      setMinHeightInput(data?.data?.UserDetails?.preference?.[0]?.min_height);
      setMaxHeightInput(data?.data?.UserDetails?.preference?.[0]?.max_height);
      setSalaryInput(data?.data?.UserDetails?.preference?.[0]?.annual_income);
      setCountry(data?.data?.UserDetails?.preference?.[0]?.country);
      setState(data?.data?.UserDetails?.preference?.[0]?.state);
      setHome_town(data?.data?.UserDetails?.preference?.[0]?.location);
      setOther(data?.data?.UserDetails?.preference?.[0]?.explanation);
      // selectedValues = data?.data?.UserDetails?.preference?.[0]?.marital_status;
      const selectedMaritual =
        data?.data?.UserDetails?.preference?.[0]?.marital_status?.map((status) => ({
          value: status,
          label: status,
        }));
      setSelectedOptionsMaritual(selectedMaritual);
      const selectedoptions2 =
        data?.data?.UserDetails?.preference?.[0]?.religion?.map((status) => ({
          value: status,
          label: status,
        }));
      setSelectedOptions2(selectedoptions2);
      const selectedoptions = data?.data?.UserDetails?.preference?.[0]?.language?.map(
        (status) => ({
          value: status,
          label: status,
        })
      );
      setSelectedOptions(selectedoptions);
      const selectedHigh =
        data?.data?.UserDetails?.preference?.[0]?.highest_qualification?.map(
          (status) => ({
            value: status,
            label: status,
          })
        );
      setSelectedOptionsHigh(selectedHigh);
      const selectedFood =
        data?.data?.UserDetails?.preference?.[0]?.food_preferences?.map((status) => ({
          value: status,
          label: status,
        }));
      setSelectedOptionsFood(selectedFood);
      const selectedDrink =
        data?.data?.UserDetails?.preference?.[0]?.drink?.map((status) => ({
          value: status,
          label: status,
        }));
      setSelectedOptionsDrink(selectedDrink);
      const selectedSmoke = data?.data?.UserDetails?.preference?.[0]?.smoke?.map(
        (status) => ({
          value: status,
          label: status,
        })
      );
      setSelectedOptionsSmoke(selectedSmoke);
    }
  };
  useEffect(() => {
    userDetails();
  }, []);

  const [ageRange, setAgeRange] = useState([18, 80]);

  const navigate = useNavigate();
  const [home_town, setHome_town] = useState("");
  const [country, setCountry] = useState("");



  useEffect(() => {
    const token = localStorage.getItem("saptvidhiUserToken");
    if (!token) {
      navigate("/");
    }
  }, []);

  const [maritalStatus, setMaritalStatus] = useState([]);
  const [religion, setReligion] = useState([]);
  const [motherTongues, setMotherTongues] = useState([]);
  const [highestQualification, setHighestQualification] = useState([]);
  const [salary, setSalary] = useState([]);
  const [foodPreference, setFoodPreference] = useState([]);
  const [drinkPreference, setDrinkPreference] = useState([]);
  const [smokePreference, setSmokePreference] = useState([]);
  const [jobTitlePreference, setJobTitlePreference] = useState([]);
  const [height, setHeight] = useState([]);

  useEffect(() => {
    loadPreference();
  }, []);

  const Token = localStorage.getItem("saptvidhiUserToken");

  const loadPreference = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/preference/preferencedata`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: Token,
          },
        }
      );
      const responseData = await response.json();
      setHeight(responseData.data.height);

      const preferenceData = responseData.data;

      setMaritalStatus(preferenceData.marital_status);
      setReligion(preferenceData.religion);
      setMotherTongues(preferenceData.mother_tongue);
      setHighestQualification(preferenceData.highest_qualification);
      setSalary(preferenceData.salary);
      setFoodPreference(preferenceData.food_preference);
      setDrinkPreference(preferenceData.drink);
      setSmokePreference(preferenceData.smoke);
      setJobTitlePreference(preferenceData.job_title);
      // Check if preference exists
      setPreferences(Object.keys(preferenceData).length > 0);
    } catch (error) {

    }
  };

  const [state, setState] = useState([]);

  const handlecounty = (e) => {
    const getcountryId = e.target.value;
    const getStatedata = country.find(
      (country) => country.country_id === getcountryId
    ).states;
    setState(getStatedata);
  };

  const ageOptions = [];
  for (let age = 18; age <= 100; age++) {
    ageOptions.push(
      <option key={age} value={age}>
        {age}
      </option>
    );
  }

  const [minHeightInput, setMinHeightInput] = useState("");
  const [maxHeightInput, setMaxHeightInput] = useState("");
  const [salaryInput, setSalaryInput] = useState("");
  const [jobTitileInput, setJobTitileInput] = useState("");
  const [other, setOther] = useState("");
  const getHeightCms = (heightString) => {
    if (!heightString) {
      return 0; // Return a default value or handle the undefined case as needed
    }

    const match = heightString.match(/\d+\s*cms/);
    if (match) {
      return parseInt(match[0]);
    }
    return 0; // Or any default value you prefer
  };
  const handleMinHeightChange = (e) => {
    const selectedMinHeight = getHeightCms(e.target.value);
    setMinHeightInput(e.target.value);
    setMaxHeightInput('');
  };

  const handleMaxHeightChange = (e) => {
    const selectedMaxHeight = getHeightCms(e.target.value);
    setMaxHeightInput(e.target.value);
  };

  const handleSalaryChange = (e) => {
    setSalaryInput(e.target.value);
  };
  const handlejobTitleChange = (e) => {
    setJobTitileInput(e.target.value);
  };

  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      selectedReligion?.length < 1 &&
      !minHeightInput &&
      !maxHeightInput &&
      selectedMaritual?.length < 1 &&
      !jobTitileInput &&
      selectedHigh?.length < 1 &&
      !salaryInput &&
      selectedFood?.length < 1 &&
      selectedDrink?.length < 1 &&
      selectedValues?.length < 1 &&
      selectedSmoke?.length < 1 &&
      !country &&
      !state &&
      !home_town &&
      !other

    ) {
      toast.error(`Please Fill All Field`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    if (selectedReligion?.length < 1) {
      toast.error(`Please Select Religion`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    if (!minHeightInput) {
      toast.error(`Please Select Min Height`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    if (!maxHeightInput) {
      toast.error(`Please Select Max Height`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedMaritual?.length < 1) {
      toast.error(`Please Select Marital Status`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!jobTitileInput) {
      toast.error(`Please Select Job Title`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedHigh?.length < 1) {
      toast.error(`Please Select Highest Qualification`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!salaryInput) {
      toast.error(`Please Select Salary Range`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedFood?.length < 1) {
      toast.error(`Please Select Food`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedSmoke?.length < 1) {
      toast.error(`Please Select Smoke`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedValues?.length < 1) {
      toast.error(`Please Select Value`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (selectedDrink?.length < 1) {
      toast.error(`Please Select Drink`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    if (minHeightInput > maxHeightInput) {
      toast.error(`Enter Correct Value For Maximum Height`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!country) {
      toast.error(`Please Select country Field`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!state) {
      toast.error(`Please Select state Field`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!home_town) {
      toast.error(`Please Select Home Town Field`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!other) {
      toast.error(`Please Enter Other Field`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    const formData = {
      marital_status: selectedMaritual,
      religion: selectedReligion,
      language: selectedValues,
      min_height: minHeightInput,
      max_height: maxHeightInput,
      job_title: jobTitileInput,
      min_age: ageRange[0],
      max_age: ageRange[1],
      highest_qualification: selectedHigh,
      annual_income: salaryInput,
      food_preferences: selectedFood,
      drink: selectedDrink,
      smoke: selectedSmoke,
      country: country,
      state: state,
      location: home_town,
      explanation: other,
    };

    setLoading(true)

    try {
      const Token = localStorage.getItem("saptvidhiUserToken");
      if (!Token) {
        throw new Error("Token is missing or invalid");
      }

      const method = localStorage.getItem("editpartenr") === "partner"
        ? "PUT"
        : "POST";

      // const method = preferences.length > 0 ? "PUT" : "POST";

      const response = await fetch(`${BASE_URL}/api/preference`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: Token,
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();

      if (responseData.code === 200) {
        const redirectPath = localStorage.getItem("editpartenr") === "partner"
          ? "/userprofile"
          : "/profile";
        navigate(redirectPath);
      } else {
        throw new Error("Failed to submit preferences");
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
    }
    finally {
      setLoading(false)
    }
  };

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptions2, setSelectedOptions2] = useState([]);
  const [selectedOptionsMaritual, setSelectedOptionsMaritual] = useState([]);
  const [selectedOptionsHigh, setSelectedOptionsHigh] = useState([]);
  const [selectedOptionsFood, setSelectedOptionsFood] = useState([]);
  const [selectedOptionsDrink, setSelectedOptionsDrink] = useState([]);
  const [selectedOptionsSmoke, setSelectedOptionsSmoke] = useState([]);

  const selectedValues = selectedOptions?.map((option) => option.value);
  const selectedReligion = selectedOptions2?.map((option) => option.value);
  const selectedMaritual = selectedOptionsMaritual?.map((option) => option.value);
  const selectedHigh = selectedOptionsHigh?.map((option) => option.value);
  const selectedFood = selectedOptionsFood?.map((option) => option.value);
  const selectedDrink = selectedOptionsDrink?.map((option) => option.value);
  const selectedSmoke = selectedOptionsSmoke?.map((option) => option.value);

  const handleSelectChange = (selectedOptions) => {

    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptions([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptions(selectedOptions);
    }
  };

  const handleSelectChange2 = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptions2([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptions2(selectedOptions);
    }
  };
  const options = motherTongues.map((motherTongue) => ({
    value: motherTongue.mt_name,
    label: motherTongue.mt_name,
  }));

  const formatOptionLabel = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const options1 = religion.map((motherTongue) => ({
    value: motherTongue.religious_name,
    label: motherTongue.religious_name,
  }));
  const formatOptionLabel1 = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const optionsMaritual = maritalStatus.map((motherTongue) => ({
    value: motherTongue.status,
    label: motherTongue.status,
  }));
  const formatOptionLabelMaritual = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const handleSelectChangeMaritual = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptionsMaritual([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptionsMaritual(selectedOptions);
    }
  };
  const optionsHigh = highestQualification.map((motherTongue) => ({
    value: motherTongue.hq_name,
    label: motherTongue.hq_name,
  }));
  const formatOptionLabelHigh = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const handleSelectChangeHigh = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptionsHigh([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptionsHigh(selectedOptions);
    }
  };
  const optionsDrink = drinkPreference.map((motherTongue) => ({
    value: motherTongue.drink_value,
    label: motherTongue.drink_value,
  }));
  const formatOptionLabelDrink = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const handleSelectChangeDrink = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptionsDrink([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptionsDrink(selectedOptions);
    }
  };
  const optionsFood = foodPreference.map((motherTongue) => ({
    value: motherTongue.fp_name,
    label: motherTongue.fp_name,
  }));
  const formatOptionLabelFood = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const handleSelectChangeFood = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptionsFood([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptionsFood(selectedOptions);
    }
  };
  const optionsSmoke = smokePreference.map((motherTongue) => ({
    value: motherTongue.smoke_value,
    label: motherTongue.smoke_value,
  }));
  const formatOptionLabelSmoke = ({ label, isSelected }) => (
    <div>
      <span>{label}</span>
      {isSelected && <span className="selected-indicator">Selected</span>}
    </div>
  );
  const handleSelectChangeSmoke = (selectedOptions) => {
    const hasDoesntMatter = selectedOptions.some(
      (option) => option.value === "Doesn't Matter"
    );
    if (hasDoesntMatter) {
      setSelectedOptionsSmoke([
        { value: "Doesn't Matter", label: "Doesn't Matter" },
      ]);
    } else {
      setSelectedOptionsSmoke(selectedOptions);
    }
  };

  const [range, setRange] = React.useState([18, 30]);
  function handleChanges(event, newValue) {
    // Ensure minimum value is not less than 18
    const adjustedValue = [
      Math.max(18, newValue[0]),
      Math.max(newValue[1], Math.max(18, newValue[0]))
    ];
    setRange(adjustedValue);
    setAgeRange(adjustedValue);
  }

  const contactnum = localStorage.getItem("contactnumber");
  const password = localStorage.getItem("password");

  const [dell, setDell] = useState({
    contact_no: contactnum,
    password: password,
  });



  const handleLogin = async () => {
    const { contact_no, password } = dell;
    const formattedContactNo = "+91" + contact_no;


    const res = await fetch(`${BASE_URL}/api/profile/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        contact_no: formattedContactNo,
        password,
      }),
    });

    const abc = await res.json();

    navigate("/profile")

    localStorage.removeItem('preference-detail');


  };

  // Add this sorting function before the return statement
  const sortedSalary = salary?.sort((a, b) => {
    // Put "Doesn't Matter" first
    if (a.salary_value === "Doesn't Matter") return -1;
    if (b.salary_value === "Doesn't Matter") return 1;
    
    // Put "No Income" second
    if (a.salary_value === "No Income") return -1;
    if (b.salary_value === "No Income") return 1;
  
    // Extract numeric values for comparison
    const aValue = parseInt(a.salary_value.replace(/[^0-9]/g, ''));
    const bValue = parseInt(b.salary_value.replace(/[^0-9]/g, ''));
    
    return aValue - bValue;
  });

  return (
    <div>
      <div className="p_login__wrapepr">
        <div className="p_login p_login-padding">
          <h2 className="title_partnerpreference pt-sm-2 pt-3">Partner Preference</h2>
          <div className="gender_state2">
            <p>Age</p>
            <Slider 
              value={range}
              onChange={handleChanges}
              valueLabelDisplay="auto"
              min={18}
              max={80}
              sx={{
                '& .MuiSlider-thumb': {
                  color: '#f97096',
                },
                '& .MuiSlider-track': {
                  color: '#f97096',
                },
                '& .MuiSlider-rail': {
                  color: '#f970964d',
                }
              }}
            />
            <small style={{ color: "#666", fontWeight:"500" }}>Age range: {range[0]} - {range[1]} years</small>
          </div>

          <div className="gender_state3">
            <p>height</p>
            <div className="height-select-group">
              <select
                className="gender min-height-select"
                value={minHeightInput}
                onChange={handleMinHeightChange}
              >
                <option value="" disabled>min Height</option>
                {height && height?.map((ele, index) => (
                  <option key={index}>{ele.height_value}</option>
                ))}
              </select>
              <select
                className="gender max-height-select"
                value={maxHeightInput}
                onChange={handleMaxHeightChange}
              >
                <option value="" disabled>
                  max Height
                </option>
                {height
                  .filter((ele) => getHeightCms(ele.height_value) > getHeightCms(minHeightInput))
                  .map((ele, index) => (
                    <option key={index}>{ele.height_value}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Marital Status</p>
            <Select
              className="gender"
              options={optionsMaritual}
              isMulti
              value={selectedOptionsMaritual}
              onChange={handleSelectChangeMaritual}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabelMaritual}
              placeholder="Select Marital Status"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Religion</p>
            <Select
              className="gender"
              options={options1}
              isMulti
              value={selectedOptions2}
              onChange={handleSelectChange2}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabel1}
              placeholder="Select Religion"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Mother Tounge</p>
            <Select
              className="gender"
              options={options}
              isMulti
              value={selectedOptions}
              onChange={handleSelectChange}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabel}
              placeholder="Select Mother Tounge"
            />
          </div>

          <div className="gender_state2">
            <p>Select Highest Qualification</p>
            <Select
              className="highest-qualification-select"
              options={optionsHigh}
              value={selectedHigh}
              onChange={handleSelectChangeHigh}
              isMulti
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                  color: "black",
                }),
                input: (provided) => ({
                  ...provided,
                  color: "black",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: "#a0a0a0",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "black",
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: "black",
                }),
              }}
              formatOptionLabel={formatOptionLabelHigh}
              placeholder="Select Highest Qualification"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Salary Range</p>
            <select
              className="gender px-2"
              value={salaryInput}
              onChange={handleSalaryChange}
              style={{
                border: "2px solid #f97096",
                height: "40px",
                borderRadius: "5px"
              }}
            >
              <option value="" disabled>Salary</option>
              {sortedSalary?.map((ele, index) => (
                <option key={index}>{ele.salary_value}</option>
              ))}
            </select>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Job Title</p>
            <select
              className="gender px-2"
              value={jobTitileInput}
              onChange={handlejobTitleChange}
              style={{
                border: "2px solid #f97096",
                height: "40px",
                borderRadius: "5px"
              }}
            >
              <option value="" disabled>JobTitle</option>
              {jobTitlePreference?.map((ele, index) => (
                <option key={index}>{ele.jt_name}</option>
              ))}
            </select>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Country</p>
            <select
              placeholder="Home town"
              // className="settle-down"
              name="country"
              id=""
              value={country}
              className=" px-2"
              style={{
                border: "2px solid #f97096",
                height: "40px",
                borderRadius: "5px"
              }}
              onChange={(e) => {
                const selectedCountry = e.target.value;
                const countryObject = countries.find((e) => e.name === selectedCountry)
                setCountry(e.target.value);
                setStates(countryObject?.states)
                setState("");
                setHome_town("");
              }}
            >
              <option value="" disabled>Select your country</option>
              {countries.map((c) => {
                return <option value={c.name}>{c.name}</option>;
              })}
            </select>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select State</p>
            <select
              placeholder="Home town"
              name="country"
              value={state}
              className=" px-2"
              style={{
                border: "2px solid #f97096",
                height: "40px",
                borderRadius: "5px"
              }}
              id=""
              onChange={(e) => {
                const selectedState = e.target.value;
                const stateObject = states?.find((e) => e.name === selectedState)
                setState(e.target.value);
                setCities(stateObject?.cities)
                setHome_town("");
              }}
            >
              <option value="" disabled>Select your State</option>
              {states?.map((c) => {
                return <option value={c.name}>{c.name}</option>;
              })}
            </select>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select City</p>
            <select
              placeholder="Home town"
              name="country"
              value={home_town}
              className="px-2"
              style={{
                border: "2px solid #f97096",
                height: "40px",
                borderRadius: "5px"
              }}
              id=""
              onChange={(e) => setHome_town(e.target.value)}
            >
              <option value="" disabled>Select your Home Town</option>
              {cities?.map((c) => {
                return <option value={c.name}>{c.name}</option>;
              })}
            </select>
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Food Preference</p>
            <Select
              className="gender"
              options={optionsFood}
              isMulti
              value={selectedOptionsFood}
              onChange={handleSelectChangeFood}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabelFood}
              placeholder="Select Food Preference"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Drink Preference</p>
            <Select
              className="gender"
              options={optionsDrink}
              isMulti
              value={selectedOptionsDrink}
              onChange={handleSelectChangeDrink}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabelDrink}
              placeholder="Select Drink"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1">Select Smoke Preference</p>
            <Select
              className="gender"
              options={optionsSmoke}
              isMulti
              value={selectedOptionsSmoke}
              onChange={handleSelectChangeSmoke}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "2px solid #f97096",
                }),
              }}
              formatOptionLabel={formatOptionLabelSmoke}
              placeholder="Select Smoke"
            />
          </div>
          <div className="gender_state2">
            <p className="mb-1 text-start">Other</p>
            <textarea
              name="bio"
              value={other}
              id="bio"

              rows="5"
              style={{ border: "2px solid rgb(249, 112, 150)", width: "100%" }}
              className="bio"
              placeholder="Other"
              onChange={(e) => setOther(e.target.value)}
              required
            ></textarea>
          </div>
          <div id="recaptcha"></div>
          {loading ? (
            <button className="text-light">
              <Loader />
            </button>
          ) : (
            <button className="text-light" onClick={handleSubmit}>
              Submit
            </button>
          )}
          <div className="skip-container">
            <p className="skip-link" style={{ marginBottom: "15px", cursor: "pointer", color: "#f97096" }} onClick={handleLogin}>
              skip
            </p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default InsertPartenerPreference;
